import React from 'react';
import { LabelValueDisplay } from '../AttributeValue';
import { Attribute } from '../attributes';
import { getLocationLabel } from './locationHelper';

type LocationAttributePreviewProps = {
    attribute: Attribute;
};

export default function LocationAttributePreview({ attribute }: LocationAttributePreviewProps) {
    const labels = Array.isArray(attribute?.value)
        ? attribute.value.map((location) => getLocationLabel(location)).filter(Boolean)
        : [getLocationLabel(attribute?.value)].filter(Boolean);

    const attributeValue = labels.length ? labels.join(', ') : undefined;

    if (!attribute) return null;

    return <LabelValueDisplay label={attribute.label} value={attributeValue || '-'} />;
}
